import {
    LOAD_FREELANCERS,
    LOADED_FREELANCERS_SUCCESS,
    SET_SELECTED_FREELANCERS,
    CREATE_MASS_BOOKING,
    CREATE_MASS_BOOKING_SUCCESS,
    CREATE_MASS_BOOKING_FAILURE,
} from '../actions';

const initialState = {
    fetching: false,
    error: undefined,
    content: [],
    meta: undefined,
    selectedFreelancers: [],
    massBookingResultsError: null,
    massBookingResults: [],
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_FREELANCERS:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case LOADED_FREELANCERS_SUCCESS:
            return {
                ...state,
                content: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        case SET_SELECTED_FREELANCERS:
            return {
                ...state,
                selectedFreelancers: action.payload,
            };
        case CREATE_MASS_BOOKING:
            return {
                ...state,
                massBookingResultsError: null,
                massBookingResults: [],
            };
        case CREATE_MASS_BOOKING_SUCCESS:
            return {
                ...state,
                massBookingResultsError: null,
                massBookingResults: action.payload,
            };
        case CREATE_MASS_BOOKING_FAILURE:
            return {
                ...state,
                massBookingResultsError: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;
